<template>
  <div class="weather-report">
    <el-dialog title="天气专报" :visible.sync="params.flag" v-dialogDrag :modal="false" :close-on-click-modal="false"
      :lock-scroll="false" :modal-append-to-body=false ref="tqzbRef"
      :before-close="() => params.flag && this.$parent.toggleProductView(this.params.productInfo.code)">
      <div class="search">
        <div class="datetime">
          <label>起止时间：</label>
          <el-date-picker v-model="datetime" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-forma="YYYY-MM-DD HH:mm:ss" :append-to-body='false'>
          </el-date-picker>
        </div>
        <div class="keywords">
          <i></i><input v-model="keywords" placeholder="请输入关键字" />
        </div>
        <div class="search-btn">
          <button @click="searchbtnClcik">搜索</button>
        </div>
      </div>
      <div class="table-data">
        <div class="table">
          <el-table :data="tableData" height="94%" style="width: 100%">
            <el-table-column prop="crttimeFmt" label="发布时间" :width="rootFontSize * 16">
              <template slot-scope="scope">
                <div>
                  <span style="position:relative">
                    {{ scope.row.crttimeFmt }}
                  </span>

                  <span class="new" v-if="(new Date(scope.row.crttimeFmt).getTime()) > (Date.now() - 3600000 * 12)">
                    new
                  </span>

                </div>
              </template>
            </el-table-column>
            <el-table-column prop="subtitle" label="专报类型" :width="rootFontSize * 15"></el-table-column>
            <el-table-column prop="gaikuang" label="概况内容"></el-table-column>
            <el-table-column label="操作" width="130px">
              <template slot-scope="scope">
                <!-- <button class="print"></button> -->
                <img src="../assets/images/更多.png" @click="showMoreDetail(scope.row)" alt="" class="image">
                <img src="../assets/images/下载.png" @click="pdfDownload(scope.row)" alt="" class="image">
                <a ref="aref"></a>
                <img>
                <!-- <i @click="showMoreDetail(scope.row)" class="el-icon-more" title="更多"></i>
                <span
                  class="el-icon-download"
                  @click="pdfDownload(scope.row)">
                  <a ref="aref"></a>
                </span> -->
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="currentPage" :page-size="pageSize" layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-dialog>

    <more-detail title="天气专报详情" width="50%" ref="tqdRed" :detailDialogVisible="detailDialogVisible"
      :morDetailConfig="morDetailConfig" :detailData="detailData" @changeDialogVisible="detailDialogVisible = false">
    </more-detail>

  </div>
</template>
<script>
import MoreDetail from './module/MoreDetail.vue'
import echarts from '@/config/echarts/index.js'
import { getMonthReportOption, getYearReportOption } from '@/config/echarts/option/report.js'
import { getFile } from '@/utils/pdf-download'
import { apiData } from '../api/index'
import { handleDownload } from '@/utils/exportFile'

export default {
  props: ['params'],
  data () {
    return {
      filePath: process.env.VUE_APP_DATA,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      datetime: null,
      keywords: '',
      tableData: [],
      monthXY: { x: [], y: [] },
      yearXY: { x: [], y: [] },
      rootFontSize: this.$rootFontSize,
      detailDialogVisible: false,
      detailData: {},
      morDetailConfig: [
        { label: '专报标题', field: 'subtitle' },
        { label: '一、', field: 'gaikuangTitle' },
        { label: '', field: 'gaikuang' },
        { label: '二、', field: 'influenceTitle' },
        { label: '', field: 'influence' },
        { label: '三、', field: 'suggestTitle' },
        { label: '', field: 'suggest' }
      ]
    }
  },
  watch: {
    'params.flag': {
      handler (flag) {
        flag && this.setZindex()
      },
      immediate: true
    }
  },
  created () {
    this.initTime()
    this.queryZhunagBao()
    // this.queryMonthYearZhunagBao()
  },
  methods: {
    // 初始换请求的时间
    initTime () {
      const currentTime = new Date().getTime()
      const day = new Date().getDate() - 1
      const startTime = this.$moment(currentTime - 86400000 * day).format('YYYY-MM-DD 00:00:00')
      const endTime = this.$moment(currentTime).format('YYYY-MM-DD 00:00:00')
      this.datetime = [startTime, endTime]
    },

    // 拼接专报的数据
    async queryZhunagBao () {
      if (!this.datetime) {
        this.$message.error('专报时间不能为空!')
        return
      }
      const company = this.$route.params.company
      const { unit } = JSON.parse(localStorage.getItem(company))
      const unitid = unit.id
      const beginCrttime = this.$moment(this.datetime[0]).format('YYYY-MM-DD 00:00:00')
      const endCrttime = this.$moment(this.datetime[1]).format('YYYY-MM-DD 23:59:59')
      const params = { beginCrttime, endCrttime, keyword: this.keywords, unitid, page: this.currentPage, pagesize: this.pageSize }
      const result = await apiData.queryZhunagBao(params)
      if (result.status === 200) {
        this.tableData = result.data.datas
        this.total = result.data.rows
      }
    },
    async queryMonthYearZhunagBao () {
      // 拼接请求参数
      const company = this.$route.params.company
      const { unit } = JSON.parse(localStorage.getItem(company))
      const unitid = unit.id
      const year = new Date().getFullYear()
      const month = (new Date().getMonth() + 1 + '').padStart(2, '0')
      const day = (new Date().getDate() + 1 + '').padStart(2, '0')
      const beginCrttime = `${year}-${month}-01 00:00:00`
      const endCrttime = `${year}-${month}-${day} 00:00:00`
      const params = { beginCrttime, endCrttime, keyword: '', unitid, page: 1, pagesize: 300 }

      // 发请求获取年，月专报的数据
      const monthResult = await apiData.queryZhunagBao(params)
      params.beginCrttime = `${year}-01-01 00:00:00`
      const yearResult = await apiData.queryZhunagBao(params)

      // 获取数据X,Y轴的数据
      this.monthXY = this.calculateTotle(monthResult.data.datas)
      this.yearXY = this.calculateTotle(yearResult.data.datas)

      this.$nextTick(() => {
        this.initEchart()
      })
    },

    //  统计专报类型的次数
    calculateTotle (data) {
      const alarnValue = {}
      const alarnType = []
      data.forEach(item => {
        const nameTitle = item.subtitle ? item.subtitle : '其他'
        const flag = alarnType.some(name => nameTitle.includes(name))
        if (!flag) {
          alarnType.push(nameTitle)
          alarnValue[nameTitle] = 0
        }
        console.log(flag, nameTitle)
        console.log(alarnValue, alarnValue, alarnType)
        alarnValue[nameTitle]++
      })
      return { x: Object.keys(alarnValue), y: Object.values(alarnValue) }
    },

    initEchart () {
      const monthChart = echarts.init(document.getElementById('month-chart1'))
      const option = getMonthReportOption(this.monthXY)
      monthChart.setOption(option)
      const yearChart = echarts.init(document.getElementById('year-chart1'))
      const yearOption = getYearReportOption(this.yearXY)
      yearChart.setOption(yearOption)
      window.addEventListener('resize', () => {
        monthChart.resize()
        yearChart.resize()
      })
    },
    searchbtnClcik () {
      this.currentPage = 1
      this.queryZhunagBao()
      this.keywords = ''
    },
    showMoreDetail (data) {
      this.detailData = data
      this.detailDialogVisible = true
      this.$nextTick(() => {
        this.$refs.tqdRed.setZindex()
      })
    },
    pdfDownload (data) {
      const url = `${process.env.VUE_APP_DATA}/zhuanbao/${data.year}/pdf/${data.filepath}.pdf`
      const options = { title: '天气专报', fileType: 'application/pdf' }
      getFile(url, options, this.$refs.aref)
    },

    downloadClcik (data) {
      const fields = []
      const header = []
      this.morDetailConfig.forEach(item => {
        header.push(item.label)
        fields.push(item.field)
      })
      handleDownload(fields, [data], header, '天气专报')
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.queryZhunagBao()
    },
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.queryZhunagBao()
    },
    closeClick () {
      console.log(this.params.flag)
      if (this.params.flag) {
        this.$parent.toggleProductView(this.params.productInfo.code)
      }
    },

    setZindex () {
      this.$nextTick(() => {
        const el = this.$refs.tqzbRef
        let zIndex = JSON.parse(localStorage.getItem('dialogZIndex'))
        zIndex = zIndex * 1 + 1
        el.$el.style.zIndex = zIndex
        localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      })
    }
  },
  components: {
    MoreDetail
  }
}
</script>
<style lang="less" scoped>
.weather-report {
  pointer-events: none;

  .search {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .datetime {
      label {
        font-size: 1rem;
        font-weight: 600;
        color: #FFF;
      }

      /deep/.el-range-editor.el-input__inner {
        height: 2.5rem;
        line-height: 2.5rem;
        width: 25rem;
        background: #5592CB;
        border: 1px solid #5592CB;

        .el-range__icon {
          line-height: 2.5rem;
          height: 2.5rem;
        }

        .el-range-separator {
          line-height: 2.5rem;
          height: 2.5rem;
          font-size: 1rem;
          color: #FFF;
        }

        .el-range-input {
          font-size: 0.88rem;
          color: #FFF;
          background: #5592CB;

        }
      }
    }

    .keywords {
      width: 30rem;
      height: 2.5rem;
      border-radius: 0.38rem;
      background: #5592CB;
      border: 1px solid #5592CB;
      display: flex;
      align-items: center;

      i {
        display: inline-block;
        width: 1.13rem;
        height: 1.06rem;
        background: url("../assets/images/搜索.png") no-repeat;
        background-size: contain;
        margin: 0 0.44rem 0 1rem;
      }

      input {
        height: 2.5rem;
        flex: 1;
        border-radius: 0.38rem;
        border: 0;
        font-size: 0.88rem;
        color: #FFF;
        outline: none;
        padding: 0 1rem 0 0;
        background: #5592CB;
      }

      input::placeholder {
        color: #FFF;
      }
    }

    .search-btn {
      button {
        padding: 0.52vw 1.09vw 0.52vw;
        border: 0;
        cursor: pointer;
        font-size: 0.73vw;
        color: #ffffff;
        background: linear-gradient(204deg, #5E9CD9 0%, rgba(66, 139, 211, 0.46) 100%);
        border-radius: 0.31vw;
        border: 0.05vw solid rgba(255, 255, 255, 0.5);
      }
    }
  }

  .table-data {
    position: relative;
    margin: 1.19rem 0;
    flex: 1;

    .table {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
    }

    // height: 31vh;
    .el-pagination {
      display: flex;
      height: 10%;
      justify-content: flex-end;
      align-items: center;
    }

    .el-table {
      background: transparent;
      text-align: center;

      /deep/ tr {
        background: transparent;

        th {
          text-align: center;
          border: 0;
          font-size: 0.88rem;
          font-weight: 600;
          color: #FFF;
          background: #3C7CB8;
        }

        td {
          text-align: center;
          font-size: 0.88rem;
          font-weight: 400;
          color: #FFF;
          border-bottom: 1px solid rgba(255,255,255,0.1);
        }

        .print {
          width: 1.13rem;
          height: 1.13rem;
          background: url("../assets/images/打印.png") no-repeat;
          border: 0;
          cursor: pointer;
          background-size: 1.13rem 1.13rem;
        }

        .image {
          margin: 0.52vw;
          width: 1.09vw;
          cursor: pointer;
        }
      }

      /deep/ tr:hover td {
        background: #3C7CB8 !important;
      }

      .new {
        margin-left: 0.52vw;
        background-color: #f56c6c;
        border-radius: 0.32vw;
        color: #fff;
        display: inline-block;
        font-size: 0.43vw;
        height: 0.94vw;
        line-height: 0.94vw;
        padding: 0.1vw 0.31vw;
        text-align: center;
        white-space: nowrap;
      }

      /deep/.el-table__body-wrapper::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }

      /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #273458;
      }

      /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #1b2230;
      }

      /deep/.el-table__body-wrapper::-webkit-scrollbar-track {
        border-radius: 5px;
        background: #0C4170;
      }

      /deep/.el-table__fixed-right-patch {
        background: #1F2C49;
        border: 0;
      }
    }

    .el-pagination {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      /deep/ .el-pager li {
        background: transparent;
        color: #FFF;
      }

      /deep/ .el-pager li.active {
        color: #6FBEFF;
      }

      /deep/ .el-pagination__total {
        color: #FFF;
      }

      /deep/ .btn-prev,
      .btn-next {
        background: transparent;
        color: #FFF;
      }

      /deep/ .btn-next {
        background: transparent;
        color: #FFF;
      }

      /deep/ .el-icon {
        color: #afa7a7
      }
    }

    .el-table::before,
    /deep/.el-table__fixed-right::before {
      background: transparent;
    }
  }

  .charts {
    flex: 1;
    display: flex;

    .chart-item {
      width: 50%;
      display: flex;
      flex-direction: column;

      .title {
        font-size: 1rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
      }

      .chart-wrap {
        flex: 1;
        position: relative;

        #month-chart1 {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
        }

        #year-chart1 {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
        }

        .no-public {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  /deep/.el-dialog__wrapper {
    overflow: hidden;

    .el-dialog {
      pointer-events: auto;
      width: 73.38rem;
      height: 73vh;
    }
  }
}
</style>
